// Matches the CSS progress circle path length value.
const PROGRESS_CIRCLE_LENGTH = 201.06;

class BackToTop {
	constructor() {
		this.backToTopBtn = document.querySelector('.back-to-top');
		if (!this.backToTopBtn) return;

		this.progressCircle = this.backToTopBtn.querySelector('.progress-circle__bar');

		this.supportsScrollTimeline =
			Boolean(window.CSS?.supports) &&
			(CSS.supports('((animation-timeline: scroll()) and (animation-range: 0% 100%))') ||
				(CSS.supports('animation-timeline', 'scroll()') && CSS.supports('animation-range', '0% 100%')));

		if (this.progressCircle) {
			this.totalLength = PROGRESS_CIRCLE_LENGTH;
			this.progressCircle.style.strokeDasharray = `${this.totalLength}`;
			if (!this.supportsScrollTimeline) {
				this.progressCircle.style.strokeDashoffset = `${this.totalLength}`;
			}
		}

		this.init();
	}

	init() {
		this.initVisibilityObserver();

		// JS Fallback for progress circle if CSS scroll-driven animations are unsupported
		if (!this.supportsScrollTimeline && this.progressCircle) {
			this.initFallbackProgress();
		}

		this.bindEvents();
	}

	initVisibilityObserver() {
		this.sentinel = document.querySelector('.w4d-back-to-top-sentinel');

		this.visibilityObserver = new IntersectionObserver(
			([entry]) => {
				const isVisible = !entry.isIntersecting;
				this.backToTopBtn.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
			},
			{
				root: null,
				threshold: 0,
			}
		);
		this.visibilityObserver.observe(this.sentinel);
	}

	initFallbackProgress() {
		let ticking = false;

		const updateProgress = () => {
			const scrollTop = window.scrollY || document.documentElement.scrollTop;
			const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;

			if (scrollHeight > 0) {
				const progress = Math.min(Math.max(scrollTop / scrollHeight, 0), 1);
				const offset = this.totalLength - progress * this.totalLength;
				this.progressCircle.style.strokeDashoffset = `${offset}`;
			}

			ticking = false;
		};

		const onScroll = () => {
			if (!ticking) {
				requestAnimationFrame(updateProgress);
				ticking = true;
			}
		};

		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onScroll, { passive: true });
		updateProgress();
	}

	bindEvents() {
		this.backToTopBtn.addEventListener('click', (e) => {
			e.preventDefault();
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
			if (window.location.hash) {
				history.pushState('', document.title, window.location.pathname + window.location.search);
			}
		});
	}
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => {
		new BackToTop();
	});
} else {
	new BackToTop();
}
